module.exports = "#account input {\n  width: 100%;\n}\n#account button {\n  width: 100%;\n  margin-top: 10px;\n}\n#account .input-container {\n  margin-top: 20px;\n}\n#account .input-container label {\n  display: block;\n  margin-bottom: 5px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/identity/identity.component.less
// module id = 500
// module chunks = 0